import { useState } from 'react'
import Modal from '@components/modal/Modal'
import Select from '@components/select/Select'
import MessageHelper from '@utils/messageHelper'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'
import withUser from '@hoc/withUser'
import useRedirectBack from '@hooks/useRedirectBack'
import { post } from '@api/apiFetcher'
import { LOGIN_PAGE } from '@constants/routes'

const REASONS = [
    { t: 'Nastąpiło wyłudzenie lub próba wyłudzenia' },
    { t: 'Niepoważna treść ogłoszenia' },
    { t: 'Nieprawdziwe dane kontaktowe' },
    { t: 'Nieprawidłowe parametry w ogłoszeniu' },
    { t: 'Użytkownik podaje się za kogoś kim nie jest' },
    { t: 'Użytkownik próbuje oszukiwać' },
    { t: 'Zdjęcia nie oddają stanu rzeczywistego' },
]

const Flag = ({ isLoggedIn, user, offer: { _user, type, _id: adId } = {}}) => {
    const { _id, token } = user || {}
    const [redirect, setRedirectPath] = useRedirectBack()
    const [open, setOpen] = useState(false)
    const [reason, setReason] = useState('')

    const zalogujSie = useT('Zaloguj się')
    const wybierzPowod = useT('Wybierz powód zgłoszenia')
    const wlasnegoOgloszenia = useT('Nie możesz zgłosić własnego ogłoszenia')

    const openUp = () => {
        if (!isLoggedIn) {
            MessageHelper.message(zalogujSie)
            setRedirectPath()
            redirect(LOGIN_PAGE)
        } else {
            if (_id === _user?._id) return MessageHelper.message(wlasnegoOgloszenia)
            setOpen(true)
        }
    }

    const onClose = () => setOpen(false)
    const onChange = ({target:{value}}) => setReason(value)
    const onSubmit = () => {
        if (!reason) {
            MessageHelper.error(wybierzPowod)
        } else {
            const path = `/api/offers/${type}/${adId}/flag`
            post({ path, data: { reason }, auth: token })
                .then(data => {
                    MessageHelper.summary(data)
                    onClose()
                })
                .catch(err => onClose())
        }
    }

    return (
        <div style={{ display: 'flex' }}>
            <button className="bt" style={{ margin: '18px 0 50px auto' }} onClick={openUp}>
                <Icon>gpp_maybe</Icon>{useT('Zgłoś naruszenie')}
            </button>

            <Modal open={open} onClose={onClose}>
                <h3>{useT('Powód zgłoszenia')}:</h3>
                <Select name="powod" options={REASONS} defaultOption={reason} onChange={onChange} />
                <br/><br/>
                <button className="bt" onClick={onSubmit}>{useT('Zgłoś')}!</button>
                <br/>
            </Modal>
        </div>
    )
}

export default withUser(Flag)